import { GET_CLIENT } from "./types"
import apiStore from "../store/ApiStore";

export const getClients = (page = 0, pagesize = 5, search = null, lastname = null, middlename = null, firstname = null, status = null, was_verification = null, was_enroll = null, sortBy = null, sortDesc = null) => {
    return {
        type: GET_CLIENT,
        items: apiStore.getClients(page , pagesize, search, lastname, middlename, firstname, status, was_verification, was_enroll, sortBy, sortDesc),
    }
};
